// extracted by mini-css-extract-plugin
export default {"button":"SecondaryBtn_button__KW5oo"};